var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgComp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48.73 48.73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#579feb;}.cls-2{fill:#f28019;}.cls-3{fill:#fff;}.cls-4{fill:#dfdfdf;}.cls-5{fill:#105baf;}.cls-6{fill:#139ae4;}.cls-7{fill:#e81c2f;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Asset 7") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 15.72,
    y: 44.8,
    width: 17.29,
    height: 3.14
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "29.86 44.8 18.86 44.8 20.43 35.37 28.29 35.37 29.86 44.8"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 0.79,
    y: 0.79,
    width: 47.15,
    height: 34.58,
    rx: 3.14
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M25.94,30.65a1.58,1.58,0,1,1-1.58-1.57A1.57,1.57,0,0,1,25.94,30.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M25.54,30.65a1.38,1.38,0,0,0-1.18-1.52,1.57,1.57,0,0,0,0,3A1.38,1.38,0,0,0,25.54,30.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M3.93,3.93H44.8v22H3.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M3.93,3.93H44.8v22H3.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M44.8,36.15H3.93A3.93,3.93,0,0,1,0,32.22V3.93A3.93,3.93,0,0,1,3.93,0H44.8a3.94,3.94,0,0,1,3.93,3.93V32.22A3.94,3.94,0,0,1,44.8,36.15ZM3.93,1.57A2.36,2.36,0,0,0,1.57,3.93V32.22a2.36,2.36,0,0,0,2.36,2.36H44.8a2.36,2.36,0,0,0,2.35-2.36V3.93A2.36,2.36,0,0,0,44.8,1.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M44.8,26.72H3.93a.79.79,0,0,1-.79-.78v-22a.8.8,0,0,1,.79-.79H44.8a.79.79,0,0,1,.78.79v22A.78.78,0,0,1,44.8,26.72ZM4.72,25.15H44V4.72H4.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M24.36,33a2.36,2.36,0,1,1,2.36-2.36A2.36,2.36,0,0,1,24.36,33Zm0-3.15a.79.79,0,1,0,.79.79A.79.79,0,0,0,24.36,29.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M29.86,45.58h-11a.78.78,0,0,1-.6-.28.75.75,0,0,1-.17-.63l1.57-9.43a.78.78,0,0,1,.77-.66h7.86a.79.79,0,0,1,.78.66l1.57,9.43a.79.79,0,0,1-.18.64A.77.77,0,0,1,29.86,45.58ZM19.79,44h9.15l-1.31-7.86H21.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M33,48.73H15.72a.79.79,0,0,1-.79-.79V44.8a.79.79,0,0,1,.79-.79H33a.78.78,0,0,1,.78.79v3.14A.78.78,0,0,1,33,48.73ZM16.5,47.15H32.22V45.58H16.5Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 31.44,
    y: 7.86,
    width: 9.43,
    height: 1.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 31.44,
    y: 11,
    width: 9.43,
    height: 1.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 31.44,
    y: 14.15,
    width: 9.43,
    height: 1.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 31.44,
    y: 17.29,
    width: 9.43,
    height: 1.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 31.44,
    y: 20.43,
    width: 9.43,
    height: 1.57
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M21.62,14.88l2.18-1.57v7.41a1,1,0,0,1-.22.63h0l-5-4.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M23.8,13.31l-2.18,1.57V12.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M23.57,21.34h0a1,1,0,0,1-.76.36H11.19a1,1,0,0,1-.76-.36h0l5-4.24h0l1,.71a1,1,0,0,0,1.16,0l1-.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M18.57,17.09l-1,.71a1,1,0,0,1-1.16,0l-1-.71-3.06-2.21V6.59h9.24v8.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M12.38,14.88l3.06,2.21h0l-5,4.24h0a1,1,0,0,1-.23-.63V13.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M12.38,12.32v2.56L10.2,13.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M21.62,6.32H12.38a.26.26,0,0,0-.25.27v5.56l-2,.92a.26.26,0,0,0-.17.24v7.41A1.27,1.27,0,0,0,11.19,22H22.82a1.28,1.28,0,0,0,1.26-1.26V13.31a.27.27,0,0,0-.17-.24l-2-.92V6.59A.25.25,0,0,0,21.62,6.32Zm1.89,14.62L19,17.1l4.55-3.28v6.9a.78.78,0,0,1,0,.22ZM21.34,6.84v7.91l-3.92,2.83a.69.69,0,0,1-.84,0l-3.92-2.83V6.84ZM10.5,20.94a.54.54,0,0,1,0-.22v-6.9L15,17.1Zm1.63-6.57-1.39-1,1.39-.63Zm-.94,7.08a.65.65,0,0,1-.36-.1l4.62-3.93.82.59a1.23,1.23,0,0,0,1.46,0l.82-.59,4.62,3.93a.64.64,0,0,1-.35.1Zm12.08-8.09-1.4,1V12.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M14.06,8.85H17a.27.27,0,1,0,0-.53H14.06a.27.27,0,0,0,0,.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M13.8,9.67a.27.27,0,0,0,.26.27h5.88a.27.27,0,1,0,0-.53H14.06A.26.26,0,0,0,13.8,9.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M19.94,10.46H14.06a.27.27,0,0,0,0,.53h5.88a.27.27,0,1,0,0-.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M19,11.55h-4.9a.26.26,0,0,0-.26.26.26.26,0,0,0,.26.26H19a.25.25,0,0,0,.26-.26A.26.26,0,0,0,19,11.55Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgComp);
export default __webpack_public_path__ + "static/media/comp.f356e9cd9d399843302ea6e79ea0cee1.svg";
export { ForwardRef as ReactComponent };